export default __webpack_public_path__ + "7d94e4a2f35f31e9d1a9161a27573c73.png";